<template>
  <div class="BracketEntry">
    <div class="entry">
      <TeamCard v-if="!(game[0] == null)" v-bind:class="{winner: team1IsWinner}" v-bind:teamId="game[0]" v-bind:edit="false" v-bind:tournamentId="tournament.id" v-on:click.native="setAsWinner(game[0])"></TeamCard>
      <EmptyCard v-else></EmptyCard>
      <TeamCard v-if="!(game[1] == null)" v-bind:class="{winner: team2IsWinner}" v-bind:teamId="game[1]" v-bind:edit="false" v-bind:tournamentId="tournament.id" v-on:click.native="setAsWinner(game[1])"></TeamCard>
      <EmptyCard v-else></EmptyCard>
    </div>
    <div v-if="!(game[0] == null && game[1] == null)" v-on:click="openComparison" class="compare"></div>
    <div v-else class="compare dark"></div>
  </div>
</template>

<script>
import TeamCard from '@/components/TeamCard.vue'
import EmptyCard from '@/components/EmptyCard.vue'
export default {
  name: 'BracketEntry',
  props: ["tournament", "game", "stageIndex", "gameIndex"],

  components: {
    TeamCard,
    EmptyCard
  },

  data: function(){
    return{

    }
  },

  computed: {
    team1IsWinner(){
      if(this.stageIndex > 0){

        var nextStage = this.$store.getters.tournament(this.tournament.id).bracket[this.stageIndex-1]
        
        for(var i = 0; i < nextStage.length; i++){
          if(nextStage[i].includes(this.game[0])){
            return true
        }
      }
      return false
      }else{
        if(this.$store.getters.tournament(this.tournament.id).status.winner == this.game[0]){
          return true
        }else{
          return false
        }
      }
    },
    team2IsWinner(){
      if(this.stageIndex > 0){

        var nextStage = this.$store.getters.tournament(this.tournament.id).bracket[this.stageIndex-1]
        
        for(var i = 0; i < nextStage.length; i++){
          if(nextStage[i].includes(this.game[1])){
            return true
          }
        }
        return false
      }else{
        if(this.$store.getters.tournament(this.tournament.id).status.winner == this.game[1]){
          return true
        }else{
          return false
        }
      }
      

    }
  },

  methods: {
    setAsWinner(teamId){
      //Update bracket unless it's stage 0 (final)
      if(this.stageIndex > 0){
        this.$store.dispatch('updateWinnerInBracket',{tournamentId: this.tournament.id, stage: this.stageIndex, game: this.gameIndex, teamId: teamId});
      }else{
        this.$store.dispatch('setTournamentStatus',{tournamentId: this.tournament.id, status: "COMPLETED", winner: teamId})
      }
    },
    openComparison(){
      if(!(this.game[0] == null || this.game[1] == null)){
        this.$router.push('/tournament/' + this.tournament.id + '/bracket/' + this.game[0] + '/vs/' + this.game[1])
      }else if(this.game[0] == null){
        this.$router.push('/tournament/' + this.tournament.id + '/bracket/' + this.game[1] + '/vs/unknown')
      }else{
        this.$router.push('/tournament/' + this.tournament.id + '/bracket/' + this.game[0] + '/vs/unknown')
      }
      
    }
  }
}
</script>

<style scoped>
.BracketEntry{
  display: grid;
  /*padding: 10px;*/
  grid-template-columns: auto 30px;
  grid-template-areas:
    'ent comp';
}

.compare{
  width: 30px;
  height: 210px;
  background-color: orange;
  background-image: url(../assets/info.png);
  background-size: 30px 210px;
  grid-area: comp;
  align-self: center;
}

.compare:hover{
  box-shadow: 0 0 10px 2px rgba(255, 166, 0, 0.25), 0 0 20px 4px rgba(255, 166, 0, 0.24);
  cursor: pointer;
}

.dark{
  background-color: rgba(51, 51, 51, 0.699);
}

.dark:hover{
  box-shadow: 0 0 10px 2px rgba(255, 166, 0, 0), 0 0 20px 4px rgba(255, 166, 0, 0);
  cursor: default;
}

.entry{
  grid-area: ent;
}

/* Bracket stuff */
.bracketWrapper{
  width: 50%;
  display: grid;
  grid-template-areas:
  's1 q1 f'
  's2 q1 f'
  's3 q2 f'
  's4 q2 f';
  padding: 10px;
  justify-items: center;
  align-items: center;
}

.bracketWrapperSize2{
  width: 50%;
  display: grid;
  grid-template-areas:
  's1 f'
  's2 f';
  padding: 10px;
  justify-items: center;
  align-items: center;
}

.BracketEntry{
  /*border-color: black;
  border-style: solid;*/
  padding-left: 10px;
  padding-right: 10px;
  /*margin: 20px;*/
  background-color: rgba(0, 0, 0, 0.2);
  width: 100%;
}


.s1{ grid-area: s1;}
.s2{ grid-area: s2;}
.s3{ grid-area: s3;}
.s4{ grid-area: s4;}
.q1{ grid-area: q1;}
.q2{ grid-area: q2;}
.f{ grid-area: f;}

@media (max-width: 600px) {
  .BracketEntry{
    padding-top: 5px;
    padding-bottom: 5px;
    margin-bottom: 10px;
    width: auto;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/BracketEntry.vue